import { useEffect, useState } from "react";
import Select from "react-select";
import { white, black, borderMuted } from "../../lib/colors";

const CustomSelect = ({ selectData }) => {
  const { fileType, handleFileTypeChange, downloadTypes } = selectData;

  const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      return document?.body?.classList?.contains("dark-mode") === true;
    } catch {
      return false;
    }
  });

  useEffect(() => {
    const body = document?.body;
    if (!body) return;

    const update = () => {
      setIsDarkMode(body.classList.contains("dark-mode"));
    };

    update();

    const observer = new MutationObserver(update);
    observer.observe(body, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  const customStylesForSelect = {
    control: (provided) => ({
      ...provided,
      border: "none",
      borderRadius: "9px 0 0 9px",
      minWidth: 52,
      width: 52,
      minHeight: 36,
      height: 36,
      boxShadow: "none",
      cursor: "pointer",
      backgroundColor: "transparent",
      ":hover": {
        border: "none",
        outline: "none",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 4px",
    }),
    menu: (provided) => ({
      ...provided,
      minWidth: 120,
      width: 120,
      marginTop: 2,
      ...(isDarkMode
        ? {
          backgroundColor: "#222432",
          color: white,
          border: "1px solid #3a6d9d",
        }
        : {
          backgroundColor: white,
          color: black,
          border: `1px solid ${borderMuted}`,
        }),
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 50010,
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
    }),
  };

  return (
    <Select
      value={fileType}
      onChange={handleFileTypeChange}
      options={downloadTypes}
      isSearchable={false}
      menuPosition="fixed"
      menuPlacement="bottom"
      menuPortalTarget={
        typeof document !== "undefined" ? document.body : null
      }
      className="downloadTypeSelect"
      classNamePrefix="downloadTypeSelect"
      components={{
        IndicatorSeparator: () => null,
        IndicatorsContainer: () => {
          return (
            <svg
              height="20"
              width="20"
              fill={isDarkMode ? "#ffffffcf" : "black"}
              viewBox="0 0 20 20"
              aria-hidden="true"
              focusable="false"
              className="css-tj5bde-Svg"
              style={{ transform: "translateX(-8px)" }}
            >
              <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
            </svg>
          );
        },
        Option: (state) => {
          const index = downloadTypes.findIndex(
            (option) => option.value === state.data.value
          );

          function handleDropDownClick(data) {
            state.selectOption(data);
          }

          return (
            <div
              {...state.innerProps}
              onClick={() => handleDropDownClick(downloadTypes[index])}
              className={
                "d-flex align-items-center " +
                (index !== downloadTypes.length - 1 ? "mb-1 pb-1" : "")
              }
              style={{
                justifyContent: "space-between",
                padding: "6px 10px",
                cursor: "pointer",
                backgroundColor: isDarkMode
                  ? state.isSelected
                    ? "#353b52"
                    : state.isFocused
                      ? "#2d3145"
                      : "#222432"
                  : state.isSelected
                    ? "#f0f0f0"
                    : state.isFocused
                      ? "#e0e0e0"
                      : white,
                color: isDarkMode ? white : black,
                ...(index !== downloadTypes.length - 1
                  ? {
                    borderBottom: isDarkMode
                      ? "1px solid #3a6d9d"
                      : `1px solid ${borderMuted}`,
                  }
                  : {}),
              }}
            >
              <img
                style={{ height: 30 }}
                src={downloadTypes[index].image}
                alt="doc-image"
                loading="lazy"
              />
              <input
                type="checkbox"
                readOnly
                checked={state.isSelected}
                style={{
                  marginRight: 8,
                  borderRadius: "50%",
                  pointerEvents: "none",
                }}
              />
            </div>
          );
        },
      }}
      formatOptionLabel={(option) => (
        <div
          className="d-flex align-items-center"
          style={{
            width: 25,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img src={option.image} alt="doc-image" loading="lazy" style={{ marginRight: "6px" }} />
        </div>
      )}
      styles={customStylesForSelect}
    />
  );
};

export default CustomSelect;
